import React from 'react';
import { BasicInput } from './BasicInput';
import { PasswordInput } from './Password/PasswordInput';
import DateOfBirth from './DateofBirth';
import { CustomRadioGroup } from './CustomRadioGroup';

export const Input = ({
  type,
  name,
  label,
  placeholder,

  value,
  onChange,

  error,
  showErrorText = true,

  sx = {},
  mask,

  ...props
}) => {
  const generateInputs = () => {
    const baseInput = (
      <BasicInput
        type="text"
        name={name}
        label={label}
        placeholder={placeholder || ''}
        value={value}
        onChange={onChange}
        error={error}
        mask={mask}
        {...props}
      />
    );

    switch (type) {
      case 'text':
        return baseInput;

      case 'mobileNumber':
        return (
          <BasicInput
            type="text"
            name={name}
            label={label}
            placeholder={'(XXX) XXX-XXXX'}
            value={value}
            onChange={onChange}
            error={error}
            mask={'(999) 999-9999'}
            {...props}
          />
        );

      case 'email':
        return (
          <BasicInput
            type="email"
            name={name}
            label={label}
            placeholder={placeholder || '@email'}
            value={value}
            onChange={onChange}
            error={error}
            {...props}
          />
        );

      case 'password':
        return (
          <PasswordInput
            name={name}
            label={label}
            placeholder={placeholder || ''}
            value={value}
            onChange={onChange}
            error={error}
            {...props}
          />
        );

      case 'dob':
        return (
          <DateOfBirth
            name={name}
            label={label}
            value={value}
            onChange={onChange}
            error={error}
            // variant="BASIC_LINE"
            {...props}
          />
        );

      case 'radio-group':
        return (
          <CustomRadioGroup onChange={onChange} error={error} {...props} />
        );

      default:
        return baseInput;
    }
  };
  return <>{generateInputs()}</>;
};

export default Input;
